<template>
    <!-- Composant qui gère les inputs numériques. -->
    <div role="form" :title="'form'+label" class="tenjityModule-item-form">
        <label :for="label" class="tenjityModule-item-unit">{{ unit }}</label>
        <input
            class="tenjityModule-item-input"
            :title="unit"
            @click.stop="handleClickInput"
            :min="min"
            :max="max"
            :id="label"
            type="number"
            :value="inputValue"
            @input="handleUpdate"
            :aria-label="ariaLabel || label || unit"
        />
    </div>
</template>

<script>
export default {
    name: "accessibilittyInput",
    props: {
        min: Number,
        max: Number,
        inputValue: Number,
        unit: String,
        label: String
        ,ariaLabel: String
    },
    methods: {
        handleClickInput($event) {
            this.$emit("handleClickInput", $event);
        },
        handleUpdate(e) {
            this.$emit("update:inputValue", +e.target.value);
        },
    },
};
</script>

<style lang="scss" scoped></style>
